import { useEffect, useState } from "react";
import { FileText, Trash2, Link2 } from "lucide-react";
import { api, formatApiError, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DOC_TYPES, blobUrl, openPdf } from "@/lib/scanOptions";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const Thumb = ({ id }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => { blobUrl(`/scans/${id}/thumb`).then(setSrc).catch(() => {}); }, [id]);
  return src ? <img src={src} alt="" className="w-full h-full object-cover" /> : <FileText className="w-6 h-6 text-slate-300" />;
};

export const ScanItem = ({ s, linkLabel, onChanged, onRelink }) => {
  const { user } = useAuth();
  const canDelete = user.role === "BROKER" || s.created_by === user.id;
  const del = async () => {
    if (!window.confirm("Belge silinsin mi?")) return;
    try { await api.delete(`/scans/${s.id}`); toast.success("Belge silindi"); onChanged(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <div data-testid={`scan-item-${s.id}`} className="flex gap-3 rounded-lg border border-slate-200 bg-white p-3 hover:border-slate-400 transition-colors">
      <button data-testid={`scan-open-${s.id}`} onClick={() => openPdf(s.id)} className="w-16 h-20 rounded bg-slate-100 overflow-hidden flex items-center justify-center shrink-0"><Thumb id={s.id} /></button>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-semibold text-sm text-slate-900 truncate">{s.title}</span>
          <Badge variant="outline" data-testid={`scan-type-${s.id}`}>{DOC_TYPES[s.doc_type]}</Badge>
        </div>
        <div className="text-xs text-slate-500 mt-0.5">{s.page_count} sayfa · {(s.size / 1024).toFixed(0)} KB · {s.created_by_name} · {formatDate(s.created_at)}</div>
        {linkLabel !== undefined && <div className="text-xs text-slate-600 mt-1 flex items-center gap-1"><Link2 className="w-3 h-3" />{linkLabel || "İlişkilendirilmedi"}</div>}
        <div className="flex gap-1.5 mt-2">
          <Button size="sm" variant="outline" className="h-7 text-xs" data-testid={`scan-pdf-btn-${s.id}`} onClick={() => openPdf(s.id)}>PDF aç</Button>
          {onRelink && canDelete && <Button size="sm" variant="outline" className="h-7 text-xs" data-testid={`scan-relink-${s.id}`} onClick={() => onRelink(s)}>İlişkilendir</Button>}
          {canDelete && <Button size="sm" variant="ghost" className="h-7" data-testid={`scan-delete-${s.id}`} onClick={del}><Trash2 className="w-3.5 h-3.5 text-red-600" /></Button>}
        </div>
      </div>
    </div>
  );
};
